import { Component,  Input } from '@angular/core';
import { Sponsor } from 'globals/store/sponsors.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'sponsor-gallery-card',
    template: `
<img *ngIf="!!sponsor.logoUrl" [src]="sponsor.logoUrl" />
<div style="flex: 1;" *ngIf="!!showName"></div>
<div class="name" *ngIf="!!showName">{{ sponsor.name }}</div>
`,
    styleUrls: ['./sponsor-gallery-card.scss'],
    standalone: true,
    imports: [CommonModule],
})

export class SponsorGalleryCardComponent {
  @Input() sponsor: Sponsor | Exhibitor
  @Input() showName = false
}
